// extracted by mini-css-extract-plugin
export default {"root":"QuizProgressBar_root-CbY","fill":"QuizProgressBar_fill-ZQE"};